import style from './style.module.scss'
import { Header } from '@crossfit/design-system'
import { Tab } from 'components/Admin/Shared/Menu/Shared/Tab'
import { TabConfig } from 'components/Admin/Shared/Menu/types'
import { useTab } from 'components/Admin/Shared/Menu/hooks'

type Props = {
  id: TabConfig['id']
  children?: React.ReactNode
  onClick?: () => void
  isExternalLink?: boolean
}

export default function TabContainer({
  id,
  children,
  onClick,
  isExternalLink,
}: Props) {
  const tab = useTab(id)
  return (
    <Tab
      id={tab.id}
      to={tab.to}
      href={isExternalLink ? tab.externalLink : tab.to}
      label={tab.label}
      isActive={(match, location) => {
        if (!match) {
          return false
        }
        return location.pathname === tab.to
      }}
      onClick={onClick}
      isExternalLink={isExternalLink}
      disableLink={tab.disableLink}
    >
      {children ? (
        <div className={style.tabWrapper}>
          <Header as='h2' size='xs' className={style.tabLabel}>
            {tab.label}
          </Header>
        </div>
      ) : (
        <Header as='h2' size='xs' className={style.tabLabel}>
          {tab.label}
        </Header>
      )}
    </Tab>
  )
}
